// Routing
export const SET_LAST_PAGE = 'SET_LAST_PAGE';

// Claims
export const CLEAR_CLAIM_DETAIL = 'CLEAR_CLAIM_DETAIL';
export const FETCH_CLAIM_LETTERS_ERROR = 'FETCH_CLAIM_LETTERS_ERROR';
export const FETCH_CLAIM_LETTERS_PENDING = 'FETCH_CLAIM_LETTERS_PENDING';
export const FETCH_CLAIM_LETTERS_SUCCESS = 'FETCH_CLAIM_LETTERS_SUCCESS';
export const FETCH_CLAIMS_ERROR = 'FETCH_CLAIMS_ERROR';
export const FETCH_CLAIMS_PENDING = 'FETCH_CLAIMS_PENDING';
export const FETCH_CLAIMS_SUCCESS = 'FETCH_CLAIMS_SUCCESS';
export const GET_CLAIM_DETAIL = 'GET_CLAIM_DETAIL';
export const SET_CLAIM_DETAIL = 'SET_CLAIM_DETAIL';
export const SET_CLAIMS_UNAVAILABLE = 'SET_CLAIMS_UNAVAILABLE';

// File uploads
export const RESET_UPLOADS = 'RESET_UPLOADS';
export const SET_UPLOADING = 'SET_UPLOADING';
export const SET_UPLOADER = 'SET_UPLOADER';
export const DONE_UPLOADING = 'DONE_UPLOADING';
export const SET_PROGRESS = 'SET_PROGRESS';
export const SET_UPLOAD_ERROR = 'SET_UPLOAD_ERROR';
export const SET_UPLOAD_RESULTS = 'SET_UPLOAD_RESULTS';
export const CLEAR_SC_ERRORS = 'CLEAR_SC_ERRORS';
export const CANCEL_UPLOAD = 'CANCEL_UPLOAD';
export const SET_UNAUTHORIZED = 'SET_UNAUTHORIZED';

// Notifications
export const CLEAR_ADDITIONAL_EVIDENCE_NOTIFICATION =
  'CLEAR_ADDITIONAL_EVIDENCE_NOTIFICATION';
export const SET_ADDITIONAL_EVIDENCE_NOTIFICATION =
  'SET_ADDITIONAL_EVIDENCE_NOTIFICATION';

export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';

// Type 1 Unknown Errors
export const SET_TYPE1_UNKNOWN_ERRORS = 'SET_TYPE1_UNKNOWN_ERRORS';

// Decision request
export const SUBMIT_DECISION_REQUEST = 'SUBMIT_DECISION_REQUEST';
export const SET_DECISION_REQUESTED = 'SET_DECISION_REQUESTED';
export const SET_DECISION_REQUEST_ERROR = 'SET_DECISION_REQUEST_ERROR';

// Appeals
export const FETCH_APPEALS_ERROR = 'FETCH_APPEALS_ERROR';
export const FETCH_APPEALS_PENDING = 'FETCH_APPEALS_PENDING';
export const FETCH_APPEALS_SUCCESS = 'FETCH_APPEALS_SUCCESS';

// Appeals error statuses
export const BACKEND_SERVICE_ERROR = 'BACKEND_SERVICE_ERROR';
export const RECORD_NOT_FOUND_ERROR = 'RECORD_NOT_FOUND_ERROR';
export const USER_FORBIDDEN_ERROR = 'USER_FORBIDDEN_ERROR';
export const VALIDATION_ERROR = 'VALIDATION_ERROR';

// Failed uploads
export const FETCH_FAILED_UPLOADS_ERROR = 'FETCH_FAILED_UPLOADS_ERROR';
export const FETCH_FAILED_UPLOADS_PENDING = 'FETCH_FAILED_UPLOADS_PENDING';
export const FETCH_FAILED_UPLOADS_SUCCESS = 'FETCH_FAILED_UPLOADS_SUCCESS';

// Intents to file
export const FETCH_INTENTS_TO_FILE_ERROR = 'FETCH_INTENTS_TO_FILE_ERROR';
export const FETCH_INTENTS_TO_FILE_PENDING = 'FETCH_INTENTS_TO_FILE_PENDING';
export const FETCH_INTENTS_TO_FILE_SUCCESS = 'FETCH_INTENTS_TO_FILE_SUCCESS';

// VES eligibility
export const FETCH_VES_ELIGIBILITY_ERROR = 'FETCH_VES_ELIGIBILITY_ERROR';
export const FETCH_VES_ELIGIBILITY_PENDING = 'FETCH_VES_ELIGIBILITY_PENDING';
export const FETCH_VES_ELIGIBILITY_SUCCESS = 'FETCH_VES_ELIGIBILITY_SUCCESS';
export const FETCH_VES_ELIGIBILITY_THROTTLED =
  'FETCH_VES_ELIGIBILITY_THROTTLED';
export const RESET_VES_ELIGIBILITY = 'RESET_VES_ELIGIBILITY';
